import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LanguageService } from '@shared/partner-ui/services/language.service';

export const authGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const language = inject(LanguageService);
  await auth.ensureInitialized();

  const currentLanguage = resolveLanguage(route, language);
  return auth.isAuthenticated() ? true : router.createUrlTree(['/', currentLanguage, 'login']);
};

function resolveLanguage(route: ActivatedRouteSnapshot, language: LanguageService): string {
  for (let index = route.pathFromRoot.length - 1; index >= 0; index -= 1) {
    const candidate = route.pathFromRoot[index].paramMap.get('lang');
    if (candidate && language.isSupportedLanguage(candidate.toLowerCase())) {
      return candidate.toLowerCase();
    }
  }
  return language.currentLanguage;
}
